module.exports = "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiODY4NjdjODE0NDRhMTRjNDFjMjYwY2Y1Mjk3MDA1YjcucG5nIjs="